import React from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { COLOR_LEGEND } from '../../../pages/run-rate-plan/colorLegend';
import styles from './ColorLegendModal.module.scss';

interface Props {
  isOpen: boolean;
  toggle: () => void;
}

interface State {
}

export default class ColorLegendModal extends React.PureComponent<Props, State> {
  render(): React.ReactNode {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        centered={true}
        size="lg"
        className={styles.colorLegendModal}
      >
        <ModalHeader toggle={this.props.toggle} className={styles.modalHeader}>
          {/* <i className="fa fa-info-circle mr-2"></i> */}
          Color Legend
        </ModalHeader>
        <ModalBody className={styles.modalBody}>
          <div className={styles.legendContainer}>
            {COLOR_LEGEND.map((section, sectionIdx) => (
              <div key={sectionIdx} className={styles.section}>
                <h6 className={styles.sectionTitle}>{section.title}</h6>
                <div className={styles.legendItems}>
                  {section.items.map((item, idx) => (
                    <div key={idx} className={styles.legendItem}>
                      <div
                        className={styles.colorBox}
                        style={{
                          backgroundColor: item.color,
                          borderColor: item.borderColor || '#ccc',
                          borderWidth: item.borderWidth || '1px'
                        }}
                      ></div>
                      <span className={styles.description}>{item.description}</span>
                      <br></br>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p className={styles.footerText}>
            These colors represent the availability ratio and discount realized for each week.
          </p>
        </ModalBody>
        <div className={styles.modalFooter}>
          <Button color="primary" onClick={this.props.toggle}>
            Close
          </Button>
        </div>
      </Modal>
    );
  }
}
